import { motion } from "framer-motion";

/**
 * Splits a string into lines by explicit \n or falls back to a single line.
 * Each line is masked (overflow-hidden) and animates Y from 100% to 0%.
 * Animates on mount by default (works reliably above the fold); pass `inView` to
 * trigger only when scrolled into view.
 */
export default function MaskedReveal({
  text,
  as: Tag = "span",
  className = "",
  delay = 0,
  stagger = 0.08,
  duration = 0.9,
  inView = false,
  once = true,
}) {
  const lines = Array.isArray(text) ? text : String(text).split("\n");
  const motionProps = inView
    ? { initial: { y: "110%" }, whileInView: { y: "0%" }, viewport: { once, margin: "-5% 0px" } }
    : { initial: { y: "110%" }, animate: { y: "0%" } };
  return (
    <Tag className={className}>
      {lines.map((line, i) => (
        <span key={i} className="mask-line">
          <motion.span
            className="inline-block will-change-transform"
            {...motionProps}
            transition={{ duration, ease: [0.22, 1, 0.36, 1], delay: delay + i * stagger }}
          >
            {line}
          </motion.span>
          {i < lines.length - 1 && <span aria-hidden="true" className="sr-only"> </span>}
        </span>
      ))}
    </Tag>
  );
}
